// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
      	colorOptionsArr: ['color', 'colour'],
    },
//   	selector: {
//         filterTreeMobileButton: '#toggleFilters'
//   	},
  	template: {
      	filterTreeMobileButton: '<button id="bc-sf-filter-tree-mobile-button" class="left btn btn--clear uppercase"><img src="' + bcSfFilterConfig.custom.filter_image_url + '" alt="' + bcSfFilterConfig.label.sidebar_more + '"/></button>',
  	}
};

// Declare Templates
var bcSfFilterTemplate = {
    // Grid Template
    'productGridItemHtml': '<div class="grid__item ' + bcSfFilterConfig.custom.grid_offset + ' ' + bcSfFilterConfig.custom.grid_width_small + ' ' + bcSfFilterConfig.custom.grid_width_medium + ' ' + bcSfFilterConfig.custom.grid_width_large + ' {{itemSaleClass}} {{itemTaggedClass}} product-grid-item">' +
                                '{{itemImages}}' +
  								'{{itemWishlist}}' +
                                '<div class="figcaption ' + bcSfFilterConfig.custom.product_grid_style + ' ' + bcSfFilterConfig.custom.collection_text_alignment + '">' +
                                    '<a href="{{itemUrl}}">' +
                                        '<p>{{itemVendor}}</p>' +
                                        '<p class="h6 name_wrapper">{{itemTitle}}</p>' +
                                        '<p class="price_wrapper">{{itemPrice}}{{itemReview}}</p>' +
                                    '</a>' +
                                '</div>' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',
  
    // Sorting Template
    'sortingHtml': '<label class="uppercase">' + bcSfFilterConfig.label.sorting + '</label><select>{{sortingItems}}</select>'
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    var new_product = false;
    var published_date = new Date(data.published_at).getTime() / 1000;
    var now_date = new Date().getTime() / 1000;
    var age_in_days = (now_date - published_date) / 3600 / 12;
    if (age_in_days < bcSfFilterConfig.custom.tag_new_limit) {
        new_product = true;
    }

    var sellout_tag = false;
    if (soldOut && bcSfFilterConfig.custom.tag_sale) {
        sellout_tag = true;
    }

    var new_tag = false;
    if (new_product && bcSfFilterConfig.custom.tag_new) {
        new_tag = true;
    }

    var sale_tag = false;
    if (onSale && bcSfFilterConfig.custom.tag_sale) {
        sale_tag = true;
    }

    var tagged = false;
    if (sellout_tag || new_tag || sale_tag ) {
        tagged = true;
    }

    var itemHtml = bcSfFilterTemplate.productGridItemHtml;
 // Swym Wishlist product data code

    //var itemWishlistHtml = '<style>.swym-button.swym-add-to-wishlist-view-product:not(.swym-loaded){display: none;}</style>';

    var itemWishlistHtml = '<script class="swym-product-view-snippet">';

    itemWishlistHtml += 'if(!window.SwymViewProducts){'

    itemWishlistHtml += 'window.SwymViewProducts = {};'

    itemWishlistHtml += '}';

    itemWishlistHtml += 'if(!window.SwymWatchProducts){';

    itemWishlistHtml += 'window.SwymWatchProducts = {};';

    itemWishlistHtml += '}';

    itemWishlistHtml += '(function(et){';

    itemWishlistHtml += 'var collections = ' + JSON.stringify(data.collections[0].title) + ';';

    itemWishlistHtml += 'var variants = [], currentVariant, variantPrice = ' + (data.price_min / 100) + ', stk;';

    itemWishlistHtml += 'if (variants.length == 0){';

    itemWishlistHtml += 'currentVariant = ' + JSON.stringify(firstVariant.id) + ';variants.push({ ' + JSON.stringify(firstVariant.title) + ' :' + JSON.stringify(firstVariant.id) + '});variantPrice = ' + (firstVariant.price / 100) + ';';

    itemWishlistHtml += 'stk = ' + firstVariant.inventory_quantity + ';';

    itemWishlistHtml += '}';

    itemWishlistHtml += 'var product_data = {';

    itemWishlistHtml += 'empi:' + JSON.stringify(data.id) + ',epi : currentVariant,';

    itemWishlistHtml += 'dt :' + JSON.stringify(data.title) + ',du  :"' + bcSfFilterConfig.shop.url + '{{itemUrl}}",';

    itemWishlistHtml += 'ct     :collections,pr     : variantPrice, stk: stk,';

    itemWishlistHtml += 'iu :' + JSON.stringify(this.getFeaturedImage(images)) + ',variants:variants';

    itemWishlistHtml += '};';

    itemWishlistHtml += 'SwymViewProducts[' + JSON.stringify(data.handle) + '] = SwymViewProducts[' + JSON.stringify(data.id) + '] = product_data;';

    itemWishlistHtml += 'var o = {};';

    for (var k in data.variants) {

        var variant = data['variants'][k]

        itemWishlistHtml += 'o[' + JSON.stringify(variant.id) + '] = {"id": ' + JSON.stringify(variant.id) + ',"inventory_management": ' + JSON.stringify(variant.inventory_management) + ',"inventory_quantity": ' + JSON.stringify(variant.inventory_quantity) + ',"title": ' + JSON.stringify(variant.title) + ', "inventory_policy": ' + JSON.stringify(variant.inventory_policy) + '};';

    }

    itemWishlistHtml += 'SwymWatchProducts[' + JSON.stringify(data.handle) + '] = SwymWatchProducts[' + JSON.stringify(data.id) + '] = o;';

    itemWishlistHtml += '})();';

    itemWishlistHtml += '</script>';

    itemWishlistHtml += '<button class="swym-button swym-add-to-wishlist-view-product product_{{itemId}}" data-swaction="addToWishlist" data-product-id="' + JSON.stringify(data.id)  +'"></button>';

    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);
  
    var itemImagesHtml = '';
    if (images.length > 1) {
        itemImagesHtml +=   '<a href="{{itemUrl}}" class="grid__image double__image">' +
                                '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}" class="collection__image__top">' +
                                '<img src="' + this.optimizeImage(images[1]['src'], '900x') + '" alt="{{itemTitle}}" class="collection__image__bottom">' +
                                '{{itemLabels}}' +
                            '</a>';
    } else {
        itemImagesHtml +=   '<a href="{{itemUrl}}" class="grid__image">' +
                                '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                '{{itemLabels}}' +
                            '</a>';
    }
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add onSale class
    var onSaleClass = onSale ? 'on-sale' : '';
    itemHtml = itemHtml.replace(/{{itemSaleClass}}/g, onSaleClass);

    // Add Tagged class
    var taggedClass = tagged ? 'tagged' : '';
    itemHtml = itemHtml.replace(/{{itemTaggedClass}}/g, taggedClass);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '900x') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
    
    // Add Labels
    var itemLabelsHtml = '';
    if (tagged) {
        if (sellout_tag) {
            itemLabelsHtml += '<div class="sticker sticker--sold">' + bcSfFilterConfig.label.sold_out + '</div>';
        } else if (sale_tag) {
            itemLabelsHtml += '<div class="sticker sticker--sale">' + bcSfFilterConfig.label.sale + '</div>';
        } else if (new_tag) {
            itemLabelsHtml += '<div class="sticker sticker--new">' + bcSfFilterConfig.label.new + '</div>';
        }
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add Price
    var saleClass = onSale ? 'on-sale' : '';
    var itemPriceHtml = '<span class="price' + saleClass + '">';
    if (priceVaries) {
        itemPriceHtml += bcSfFilterConfig.label.from_price + ' ';
    }
    itemPriceHtml += '<span class="money" style="font-weight:bold;font-size:12px">' + this.formatMoney(data.price_min) + '</span>';
  	itemPriceHtml += '</span>';
  	itemPriceHtml += ' &nbsp;<span style="font-size:10px"> | </span>&nbsp;';
    if (soldOut) {
        itemPriceHtml += '<br /><em>' + bcSfFilterConfig.label.sold_out + '</em>';
    }
    if (onSale) {
        itemPriceHtml += '<span class="money" style="color:grey; font-size:12px" >' + this.formatMoney(data.compare_at_price_min) + ' retail</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Review
    var itemReviewHtml = '';
    if (this.getProductMetafield(data, 'stamped', 'badge') !== null) {
        itemReviewHtml = '<br /><span class="stamped-product-reviews-badge" data-id="{{itemId}}">' + this.getProductMetafield(data, 'stamped', 'badge') + '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemReview}}/g, itemReviewHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data) {
    // Integrate Product Review
    !function(){var e=function(e){var t={exports:{}};return e.call(t.exports,t,t.exports),t.exports};e(function(){"use strict";window.innerShiv=function(){function e(e,t,r){return/^(?:area|br|col|embed|hr|img|input|link|meta|param)$/i.test(r)?e:t+"></"+r+">"}var t,r,a=document,i="abbr article aside audio canvas datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video".split(" ");return function(n,s){if(!t&&(t=a.createElement("div"),t.innerHTML="<nav></nav>",r=1!==t.childNodes.length)){for(var o=a.createDocumentFragment(),d=i.length;d--;)o.createElement(i[d]);o.appendChild(t)}if(n=n.replace(/^\s\s*/,"").replace(/\s\s*$/,"").replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"").replace(/(<([\w:]+)[^>]*?)\/>/g,e),t.innerHTML=(o=n.match(/^<(tbody|tr|td|col|colgroup|thead|tfoot)/i))?"<table>"+n+"</table>":n,o=o?t.getElementsByTagName(o[1])[0].parentNode:t,!1===s)return o.childNodes;for(var d=a.createDocumentFragment(),u=o.childNodes.length;u--;)d.appendChild(o.firstChild);return d}}()});(function(){window.SPR=function(){function e(){}return e.shop=Shopify.shop,e.host="//productreviews.shopifycdn.com",e.version="v4",e.api_url=e.host+"/proxy/"+e.version,e.badgeEls=[],e.reviewEls=[],e.elSettings={},e.$=void 0,e.extraAjaxParams={shop:e.shop},e.registerCallbacks=function(){return this.$(document).bind("spr:badge:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onBadgeLoad:void 0),this.$(document).bind("spr:product:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onProductLoad:void 0),this.$(document).bind("spr:reviews:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onReviewsLoad:void 0),this.$(document).bind("spr:form:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormLoad:void 0),this.$(document).bind("spr:form:success","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormSuccess:void 0),this.$(document).bind("spr:form:failure","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormFailure:void 0)},e.loadStylesheet=function(){var e,t;return t=document.createElement("link"),t.setAttribute("rel","stylesheet"),t.setAttribute("type","text/css"),t.setAttribute("href","https://productreviews.shopifycdn.com/assets/v4/spr-5a2d2fd286dca8042a3a5a76bc9032c64c52a2792a734307c76740d012641514.css"),t.setAttribute("media","screen"),e=document.getElementsByTagName("head")[0],e.appendChild(t)},e.initRatingHandler=function(){return e.$(document).on("mouseover mouseout","form a.spr-icon-star",function(t){var r,a,i;return r=t.currentTarget,i=e.$(r).attr("data-value"),a=e.$(r).parent(),"mouseover"===t.type?(a.find("a.spr-icon:lt("+i+")").addClass("spr-icon-star-hover"),a.find("a.spr-icon:gt("+(i-1)+")").removeClass("spr-icon-star-hover")):a.find("a.spr-icon").removeClass("spr-icon-star-hover")})},e.initDomEls=function(){return this.badgeEls=this.$(".shopify-product-reviews-badge[data-id]"),this.reviewEls=this.$("#shopify-product-reviews[data-id]"),this.$.each(this.reviewEls,function(e){return function(t,r){var a;return a=e.$(r).attr("data-id"),e.elSettings[a]={},e.elSettings[a].reviews_el="#"+(e.$(r).attr("data-reviews-prefix")?e.$(r).attr("data-reviews-prefix"):"reviews_"),e.elSettings[a].form_el="#"+(e.$(r).attr("data-form-prefix")?e.$(r).attr("data-form-prefix"):"form_")}}(this))},e.loadProducts=function(){return this.$.each(this.reviewEls,function(e){return function(t,r){var a,i;if(a=e.$(r).attr("data-id"),"false"!==e.$(r).attr("data-autoload"))return i=e.$.extend({product_id:a,version:e.version},e.extraAjaxParams),e.$.get(e.api_url+"/reviews/product",i,e.productCallback,"jsonp")}}(this))},e.loadBadges=function(){var e,t,r,a,i;if(r=this.$.map(this.badgeEls,function(e){return function(t){return e.$(t).attr("data-id")}}(this)),r.length>0){for(t=7,i=[];(e=r.splice(0,t)).length>0;)a=this.$.extend(this.extraAjaxParams,{product_ids:e}),i.push(this.$.get(this.api_url+"/reviews/badges",a,this.badgesCallback,"jsonp"));return i}},e.pageReviews=function(e){var t,r,a;return a=this.$(e).data("product-id"),r=this.$(e).data("page"),t=this.$.extend({page:r,product_id:a},this.extraAjaxParams),this.$.get(this.api_url+"/reviews",t,this.paginateCallback,"jsonp"),!1},e.submitForm=function(e){var t;return t=this.$(e).serializeObject(),t=this.$.extend(t,this.extraAjaxParams),t=this.$.param(t),t=t.replace(/%0D%0A/g,"%0A"),this.$.ajax({url:this.api_url+"/reviews/create",type:"GET",dataType:"jsonp",data:t,success:this.formCallback,beforeSend:function(e){return function(){return e.$(".spr-button-primary").attr("disabled","disabled")}}(this),complete:function(e){return function(){return e.$(".spr-button-primary").removeAttr("disabled")}}(this)}),!1},e.reportReview=function(e){var t;return confirm("Are you sure you want to report this review as inappropriate?")&&(t=this.$.extend({id:e},this.extraAjaxParams),this.$.get(this.api_url+"/reviews/report",t,this.reportCallback,"jsonp")),!1},e.toggleReviews=function(e){var t;return t=this.$("#shopify-product-reviews[data-id='"+e+"']"),t.find(".spr-reviews").toggle()},e.toggleForm=function(e){var t;return t=this.$("#shopify-product-reviews[data-id='"+e+"']"),t.find(".spr-form").toggle()},e.setRating=function(e){var t,r,a;return t=this.$(e).parents("form"),a=this.$(e).attr("data-value"),r=this.$(e).parent(),t.find("input[name='review[rating]']").val(a),this.setStarRating(a,r)},e.setStarRating=function(e,t){return t.find("a:lt("+e+")").removeClass("spr-icon-star-empty spr-icon-star-hover"),t.find("a:gt("+(e-1)+")").removeClass("spr-icon-star-hover").addClass("spr-icon-star-empty")},e.badgesCallback=function(t){var r;return r=t.badges,e.$.map(e.badgeEls,function(t){var a;if(a=e.$(t).attr("data-id"),r[a]!==undefined)return e.$(t).replaceWith(r[a]),e.triggerEvent("spr:badge:loaded",{id:a})})},e.productCallback=function(t){var r;return r=t.remote_id.toString(),e.renderProduct(r,t.product),e.renderForm(r,t.form),e.renderReviews(r,t.reviews)},e.renderProduct=function(e,t){return this.$.map(this.reviewEls,function(r){return function(a){if(e===r.$(a).attr("data-id"))return r.$(a).html(innerShiv(t,!1)),r.triggerEvent("spr:product:loaded",{id:e})}}(this))},e.renderForm=function(e,t){var r;return r=this.$(this.elSettings[e].form_el+e),r.html(t),this.triggerEvent("spr:form:loaded",{id:e})},e.renderReviews=function(t,r){var a;return a=e.$(e.elSettings[t].reviews_el+t),a.html(r),e.triggerEvent("spr:reviews:loaded",{id:t})},e.formCallback=function(t){var r,a,i,n;return n=t.status,i=t.remote_id,a=t.form,r=e.$(e.elSettings[i].form_el+i),r.html(a),"failure"===n&&e.initStarRating(r),"success"===n&&e.$("#shopify-product-reviews[data-id='"+i+"'] .spr-summary-actions-newreview").hide(),e.triggerEvent("spr:form:"+n,{id:i})},e.initStarRating=function(e){var t,r,a;if((a=e.find("input[name='review[rating]']"))&&a.val())return r=a.val(),t=e.find(".spr-starrating"),this.setStarRating(r,t)},e.paginateCallback=function(t){var r,a;return a=t.remote_id.toString(),r=t.reviews,e.renderReviews(a,r)},e.reportCallback=function(t){var r;return r="#report_"+t.id,e.$(r).replaceWith("<span class='spr-review-reportreview'>"+e.$(r).attr("data-msg")+"</span>")},e.loadjQuery=function(t){return e.loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js",function(){return e.$=jQuery.noConflict(!0),t()})},e.loadScript=function(e,t){var r;return r=document.createElement("script"),r.type="text/javascript",r.readyState?r.onreadystatechange=function(){if("loaded"===r.readyState||"complete"===r.readyState)return r.onreadystatechange=null,t()}:r.onload=function(){return t()},r.src=e,document.getElementsByTagName("head")[0].appendChild(r)},e.loadjQueryExtentions=function(e){return e.fn.serializeObject=function(){var t,r;return t={},r=this.serializeArray(),e.each(r,function(){return t[this.name]?(t[this.name].push||(t[this.name]=[t[this.name]]),t[this.name].push(this.value||"")):t[this.name]=this.value||""}),t}},e.triggerEvent=function(e,t){return this.$(document).trigger(e,t)},e}(),function(){SPR.loadStylesheet(),SPR.loadjQuery(function(){return SPR.$.ajaxSetup({cache:!1}),SPR.loadjQueryExtentions(SPR.$),SPR.$(document).ready(function(){return SPR.registerCallbacks(),SPR.initRatingHandler(),SPR.initDomEls(),SPR.loadProducts(),SPR.loadBadges()})})}()}).call(this)}("undefined"!=typeof global?global:"undefined"!=typeof window&&window);
  
  	window.pipeline = window.pipeline || {};
  	$(pipeline.init);
  
   if (window._swat) {

        window._swat.initializeActionButtons("#bc-sf-filter-products");

      } else {

        window.SwymCallbacks = window.SwymCallbacks || [];

        window.SwymCallbacks.push(function() {

          window._swat.initializeActionButtons("#bc-sf-filter-products");

        });

      }
};



// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data) {
};

// Build Filter scrollbar
BCSfFilter.prototype.buildFilterScrollbar = function(element) {
    var _this = this;

    if (typeof element !== 'undefined') {
        if (!jQ(element).hasClass('no-scrollbar') && jQ(element)[0].scrollHeight > jQ(element)[0].clientHeight) {
            jQ(element).css('overflow-y', 'scroll');
        }
    } else {
        jQ('.' + this.class.filterOption).each(function() {
            if (jQ(this).data('show-more-type') == 'scrollbar') {
                _this.buildFilterScrollbar(jQ(this).find('.' + _this.class.filterBlockContent));
            }
        });
    }

    // Scroll to the last position of each filter options
    if (this.getSettingValue('general.keepScrollState')) {
        if (this.hasOwnProperty('scrollData') && this.scrollData.length > 0) {
            for (var i in this.scrollData) {
                var scroll = this.scrollData[i];
                if (jQ('div[data-block-id="' + scroll.id + '"]').find('.jspScrollable').length > 0) {
                    var api = jQ('div[data-block-id="' + scroll.id + '"]').find('.jspScrollable').eq(0).data('jsp');
                    if (typeof api !== 'undefined') {
                        api.scrollToY(parseInt(scroll.position));
                    }
                }
            }
        }
    }
};
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
